/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Footer_GuideInputs */

const en_fc_footer_guide = /** @type {(inputs: Fc_Footer_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guide`)
};

/**
* | output |
* | --- |
* | "Guide" |
*
* @param {Fc_Footer_GuideInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_footer_guide = /** @type {((inputs?: Fc_Footer_GuideInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Footer_GuideInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_footer_guide(inputs)
});
export { fc_footer_guide as "fc.footer.guide" }